import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FaAngleDown,
  FaBell,
  FaChartLine,
  FaCog,
  FaFileAlt,
  FaHistory,
  FaHome,
  FaMoneyBillWave,
  FaTable,
  FaUserAstronaut,
  FaUsers,
  FaUserShield
} from "react-icons/fa";

const TopNavbar = () => {

  const [activeKey, setActiveKey] = useState("dashboard");
  const [openDropdown, setOpenDropdown] = useState(null);
  const authState = useSelector((state) => state.auth);
  const designation = (authState?.auth?.DesignationName || authState?.auth?.designation || authState?.auth?.Designation || '').toString().toLowerCase();





  useEffect(() => {
    if (!openDropdown) return;
    const handleBodyClick = (e) => {

      if (e.target.closest('.custom-dropdown-body')) return;
      setOpenDropdown(null);
    };
    document.addEventListener('mousedown', handleBodyClick);
    return () => document.removeEventListener('mousedown', handleBodyClick);
  }, [openDropdown]);

  const toggleDropdown = (key) => {
    setOpenDropdown((prevKey) => (prevKey === key ? null : key));
  };

  const isDropdownActive = (dropdownKey) => activeKey.startsWith(dropdownKey);




  const navItems = [
    {
      key: "dashboard",
      
      icon: <FaHome className="me-1" size={17} />,
      isDropdown: false,
      to: "dashboard",
    },
    {
      key: "astrologer",
      title: "Astrologer",
      icon: <FaUserAstronaut className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "Manage Astrologers",
          items: [
            { key: "astrologer-list", title: "Astrologer List", to: "astrolist" },
           
            { key: "gallery-approvals", title: "Pending Gallery Approvals", to: "astrogallery" },
             { key: "profile-approvals", title: "Pending Profile Photo Approvals", to: "astroprofilephoto" },
            { key: "pending-approvals", title: "Pending Approvals", to: "pendingapporeval" },
            { key: "pricechange", title: "Astrologer Price Change", to: "astrologerpricechange" },
            { key: "videopricechange", title: "Astrologer Video Price Change", to: "astrovideopricechange" },
            { key: "astrologertransaction", title: "Astrologer Transaction", to: "AstrowalletTransaction" },
            { key: "astrologersalary", title: "Astrologer Salary", to: "astrologersalary" },
            { key: "astrologersummery", title: "Astrologer Summery", to: "astorlogersummery" },
            {key:"waitinglisthistory",title:"Waiting List History",to:"waitinglisthistory"},
            {key:"astrototaltime",title:"Astrologer Total Login Time",to:"astrototaltime"},
             {key:"astrologergiftcard",title:"Astrologer Gift Card",to:"astrologergiftcard"},
             {key:"astrologercontactshare",title:"Astrologer Contact Sharing",to:"astrologermobileno"},
          

          ]
        },
       
        {
          heading: "Recommendations",
          items: [
            { key: "suggested-gemstone", title: "Suggested Gemstone", to: "suggestiongemstone" },
            { key: "suggested-online-puja", title: "Suggested Online Puja", to: "suggestionpoja" }
          ]
        },
        {
          heading: "Communication",
          items: [
            { key: "weekly-calendar", title: "Astrologers Weekly Calendar", to: "weeklycalendar" },
            { key: "live-status-panel", title: "Astrologer Live Status Panel", to: "astrologerLiveStatus" }
          ]
        }
      ]
    },
    {
      key: "user",
      title: "Users",
      icon: <FaUsers className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "User Management",
          items: [
            { key: "user-list", title: "User List", to: "userlist" },
            {key:"couponcode", title:"Coupon Code", to:"couponcode"},
          
            { key: "notloginuser", title: "Not login User", to: "notloginuser" },
            { key: "paymentpagevisit", title: "Payment Page visitCustomer", to: "paymentpagevisitors" },
             {key:"usersummery",title:"User Summery",to:"usersummery"},
               {key:"Registration-Hour",title:"Registration Peak Hour",to:"callchatpeachour"},
               {key:"Registration-Age",title:"User Registration Age",to:"userregage"},
                 { key:"callchatstatus", title: "Call/Chat Status", to: "callchatstatus" },
           
          ]
        },
        {
          heading: "Finance & Feedback",
          items: [
            { key: "user-Review", title: "All Review", to: "userreview" },
          
            { key: "wallet-logs", title: "Wallet & Transactions", to: "userwalletTransaction" },
             { key: "ticket", title: "Tickets", to: "Tickets" },
             {key: "user-activity-rules", title: "User Activity Rules", to: "useractivityrules"},
          

          ]
        },
       
      ]
    },
    {
      key: "communication",
      title: "Call & Chat",
      icon: <FaHistory className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "History & Sessions",
          items: [
          
            { key: "call-history", title: "Call History", to: "CallHistory" },
            { key: "chat-history", title: "Chat History", to: "ChatHistory" },
            { key: "chat-history-analysis", title: "Chat History Analyze", to: "chathistoryanalysis" },
            { key: "pending-call-chat", title: "Pending Call/chat", to: "pendingcallchat" },
            
           
          ]
        },
         {
          heading: "Marketing Contacts",
          items: [
             { key: "marketing-contacts", title: "Marketing Contacts", to: "marketingcontacts" },
            { key: "list-marketing-contacts", title: "Marketing Contacts Category", to: "listmarketingcontact" },
          
          ]
        },
       
      ]
    },
    {
      key: "puja",
      title: "Online Puja",
      icon: <FaFileAlt className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "Puja Management",
          items: [
            { key: "puja-categories", title: "Puja Categories", to: "PoojaFor" },
            { key: "puja-list", title: "Puja List", to: "PoojaList" },
            { key: "new-booking", title: "New Booking List", to: "PujaListFilter" },
           
          ]
        },
       
      ]
    },
    {
      key: "gemstone",
      title: "Gemstone",
      icon: <FaMoneyBillWave className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "Gemstone Management",
          items: [
            { key: "gemstone-list", title: "Gemstone List", to: "GemstoneList" },
            { key: "gemstone-Category", title: "Gemstone Category", to: "Gemstone" },
            { key: "gemstone-booking", title: "New Booking", to: "GemstoneListFilter" },
           
          ]
        },
       
      ]
    },
    {
      key: "blog",
      title: "Blog",
      icon: <FaFileAlt className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "Content",
          items: [
            { key: "blog-list", title: "Blog List", to: "Blog" },
            { key: "category", title: "Blog Category", to: "BlogCategoryList" },
            { key: "authorname", title: " Add Author name", to: "authorname" },
          { key: "Faq", title: "FaQ", to: "Horoscope" }
          
          ]
        }
      ]
    },
    {
      key: "finance",
      title: "Financial",
      icon: <FaMoneyBillWave className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "Income",
          items: [
            // { key: "daily_bussines_summery", title: "Daily Income Summary", to: "dailyincomesummary" },
            { key: "addincome_entry", title: "Add Income Entry", to: "IncomeCategoryAdd" },
            { key: "recharge-package", title: "Recharge Package", to: "Wallet" },
           { key: "package-rule", title: "Package Rules", to: "packageroles" },
            { key: "package-rule-category", title: "Add Package Name", to: "walletpackagename" },
          ]
        },
        {
          heading: "Expense",
          items: [
            { key: "add-expense", title: "Expense Details", to: "ExpenseDetails" },
            { key: "expense-category", title: "Expense Category", to: "ExpenseCategory" },
            { key: "addexpense_entry", title: "Add Expenses Entry", to: "AddExpenseEntry" },
             { key: "service_provider", title: "Service Provider", to: "ServiceProvider"}
          ]
        }, {
          heading: "Company",
          items: [
            { key: "Transaction", title: "Transaction", to: "Transaction" },
            { key: "add-company", title: "Add Company", to: "Addcompany" },
              { key: "income-Transaction", title: "Income Transaction", to: "IncomeTransaction" }
          ]
        }
      ]
    },

    {
      key: "notification",
      title: "Notification ",
      icon: <FaBell className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "Notifications",
          items: [
            { key: "create-notification", title: "Send Notification", to: "notificationrulelist" },
            { key: "notification-rule", title: "Notification Roles", to: "notificationrule" },
            { key: "notification-rule-category", title: "Notification Roles category", to: "redirectcategory" },
            { key: "notification-message", title: "Notification Message", to: "notificationmessage" },
            { key: "notification-queue", title: "Notification Queue", to: "notificationqueue" },
           
            { key: "notification-history", title: "Notification History", to: "notificationhistory" },
            { key: "notification-traking", title: "Notification Tracking", to: "notificationtraking" },
            { key: "topic-wise-notification", title: "Topic-Wise Notification", to: "topicwisenotification" },
            { key: "topic-wise-rules", title: "Topic-Wise Rules", to: "topicwiserules" },
               { key: "topic-wise-rules Category", title: "Topic-Wise Rules Category", to: "topicwiserulescategory" },
           
          ]
        }
      ]
    },
   
     {
      key: "ca",
      title: "Ca",
      icon: <FaMoneyBillWave className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
        heading: "C A Pages",
          items: [
            { key: "Transaction", title: "Company Transaction", to: "Transaction" },
            { key: "add-expense", title: "Expense Details", to: "ExpenseDetails" },
           
        
         
           
          ]
        }
      ]
    },
    {
      key: "admin",
      title: "Admin ",
      icon: <FaUserShield className="me-1" size={17} />,
      icons: <FaAngleDown className="ms-1" size={12} />,
      isDropdown: true,
      items: [
        {
          heading: "Admin Control",
          items: [
            { key: "admin-list", title: "Admin List", to: "AdminUserList" },
            { key: "roles", title: "Role-Based Access", to: "rolebaseaccess" },
            {key:"dailysummery",title:"Daily-Summery",to:"dailysummeryreport"},
          
            { key: "allmenupages", title: "All Admin Menu Pages", to: "allmenupages" },
            {key:"adminactivitylog",title:"Today Acitivity Page",to:"mostactivitypage"}
          ]
        }
      ]
    },
    {
      key: "settings",
      icon: <FaCog className="me-1" size={17} />,
      isDropdown: true,
      items: [
        {
          heading: "Master Table", items: [
             { key: "interpretationCategory", title: "Astrologer Interpretation Category", to: "interpretationcategory" },
             { key: "interpretationRules", title: "Astrologer Interpretation Rules", to: "interpretationrules" },
            { key: "SkillsList", title: "Astrologer Skills", to: "SkillsList" },
            { key: "LanguagesList", title: "Astrologer Language", to: "LanguagesList" },

            { key: "DregeeDiploma", title: "Astrologer Deegree", to: "DregeeDiploma" },
            { key: "AstrologersCategory", title: "Astrologer Category", to: "AstrologersCategory" },
            { key: "MuhuratCategory", title: "Muhurat Category", to: "MuhuratCategory" },
            { key: "VratUpvaasCategory", title: "VratUpvaas Category", to: "VratUpvaasCategory" },

            { key: "ExpenseCategory", title: "Expense Category", to: "ExpenseCategory" },
            { key: "TransactionCategory", title: "Transaction Category", to: "TransactionCategory" },
            { key: "IncomeCategory", title: "Income Category", to: "IncomeCategory" },

          ]
        }, {
          heading: "Homepage Frontend", items: [
            { key: "contacts", title: "Contacts", to: "Contact" },
            { key: "TrustedbyPopularsVideos", title: "Trusted by Populars Videos", to: "Video" },
            { key: "HomeSlider", title: "Home Slider", to: "HomeSlider" },
            { key: "TicketCategory", title: "Ticket Category", to: "TicketCategory" },

            { key: "policy", title: "Policy", to: "policy" },
            { key: "Muhurat", title: "Muhurat", to: "Muhurat" },
            { key: "VratUpvaas", title: "Vrat Upvaas", to: "VratUpvaas" },
            { key: "festival", title: "festival", to: "festival" }



          ]
        }
      ]
    },
  ];

  const filteredNavItems = designation === 'ca'
    ? navItems.filter((item) => item.key === 'ca')
    : navItems;

  return (
   

    <Navbar
      bg="white"
      expand="lg"
      className="px-2 z-9999"
      style={{ boxShadow: "inset 0 calc(-1 * 1px) 0 0 #ddd", whiteSpace: "nowrap" }}
    >
     
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />

    
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav
          className="d-flex align-items-start align-items-lg-center gap-2 fs-5 
                 flex-column flex-lg-row"   
          style={{ paddingLeft: "30px", paddingRight: "30px" }}
          activeKey={activeKey}
          onSelect={(selectedKey) => setActiveKey(selectedKey)}
        >
          {filteredNavItems.map((item) =>
            item.isDropdown ? (
              <div key={item.key} style={{ position: "relative" }}>
                <span
                  onClick={() => toggleDropdown(item.key)}
                  className={`nav-link-with-border ${isDropdownActive(item.key) ? "active-link" : ""
                    } d-flex align-items-center cursor-pointer`}
                  style={{
                    cursor: "pointer",
                    padding: "8px 8px",
                    borderBottom:
                      openDropdown === item.key
                        ? "3px solid red"
                        : "3px solid transparent",
                    boxShadow: "none",
                    borderColor: "transparent",
                  }}
                >
                  {item.icon}
                  {item.title}
                  {item.icons}
                </span>

                {openDropdown === item.key && (
                  <div
                    className="custom-dropdown-body"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: ["settings", "admin"].includes(item.key) ? "auto" : 0,
                      right: ["settings", "admin"].includes(item.key) ? 0 : "auto",
                      background: "#fff",
                      display: "flex",
                      padding: "15px 20px",
                      zIndex: 1000,
                      border: "1px solid #ddd",
                      maxWidth: "100vw",
                      overflowY: "auto",
                      overflowX: "auto",
                      flexWrap: "nowrap",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                  >
                    {item.items.map((section, index) => (
                      <div key={`col-${index}`} style={{ minWidth: "200px" }}>
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginBottom: "6px",
                            fontWeight: "600",
                          }}
                        >
                          {section.heading}
                        </div>
                        {section.items.map((subItem) => (
                          <NavDropdown.Item
                            as={Link}
                            to={`/${subItem.to || subItem.key}`}
                            key={subItem.key}
                            eventKey={subItem.key}
                            onClick={() => {
                              setActiveKey(subItem.key);
                              setOpenDropdown(null);
                            }}
                            style={{
                              padding: "6px 10px",
                              fontSize: "12px",
                            }}
                          >
                            {subItem.title}
                          </NavDropdown.Item>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Nav.Link
                key={item.key}
                as={Link}
                to={item.to || `/${item.key}`}
                eventKey={item.key}
                className={`${activeKey === item.key ? "active-link" : ""
                  } nav-link-with-border`}
                onClick={() => setActiveKey(item.key)}
              >
                {item.icon}
                {item.title}
                {item.icons}
              </Nav.Link>
            )
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>


  );
};

export { TopNavbar };

